import { ConfirmationDialog, ModalInjectedProps } from '@sketch/components'
import React from 'react'

import { useToast } from '@sketch/toasts'
import { useUpdateWorkspaceProfileMutation } from '@sketch/gql-types'

interface PublishProfileModalProps extends ModalInjectedProps {
  identifier: string
}

export const PublishProfileModal: React.FC<
  PublishProfileModalProps
> = props => {
  const { hideModal, isModalOpen, identifier } = props
  const { showToast } = useToast()

  const [publishProfile, { loading }] = useUpdateWorkspaceProfileMutation({
    onCompleted: () => {
      showToast('Public profile successfully published')
      hideModal()
    },
    onError: message => showToast(message, 'negative'),
    variables: {
      input: {
        identifier,
        isPublic: true,
      },
    },
  })

  return (
    <ConfirmationDialog
      title="Publish Documents?"
      hideModal={hideModal}
      isModalOpen={isModalOpen}
      cancelButton={{
        disabled: loading,
      }}
      confirmButton={{
        text: 'Publish',
        variant: 'primary',
        loading,
        disabled: loading,
      }}
      onConfirm={() => publishProfile()}
    >
      <p>
        These Documents will be available publicly for everyone to see. Are you
        sure you wish to publish them?
      </p>
    </ConfirmationDialog>
  )
}
